export default function (val) {
  return val !== null && typeof val !== "undefined" && val !== "";
}
